import type { SearchResult, Searchable, SearchablesQuery, StartIndexType } from '../../@types';

export default class LocalFileSearch implements Searchable {
	searchParams: Record<string, any> = {};
	name = 'LocalFileSearch';

	constructor(params: Record<string, any>) {
		this.searchParams = params;
	}

	search(query: SearchablesQuery, startIndex: StartIndexType, limit: number): Promise<SearchResult> {
		let promise;

		if (this.searchParams.hostContext?.search) {
			promise = new Promise(async (resolve) => {
				const startTime = Date.now();
				const results = await this.searchParams.hostContext.search(query, startIndex, limit);
				results.duration = Date.now() - startTime;
				resolve(results);
			});
		} else {
			promise = new Promise((resolve) => {
				resolve({
					resultItems: [],
					serverResult: {
						url: 'LocalFileSearch',
						message: 'HostContext search() method is not defined',
						requestId: '0',
						status: 404,
						duration: 0,
					},
					totalResults: 0,
					duration: 0,
				});
			});
		}

		return promise;
	}
}
